export const defaultCurrency = '£';
